import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import Constant from "../library/Constant";
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import api from "./api";
import { Typography } from "@material-ui/core";

export default function PreviewFAQ(props) {
    const location = useLocation()
    const [content, setContent] = useState("")
    const [title, setTitle] = useState("")
    const editorRef = useRef();

    useEffect(() => {
        console.log(location);
        getData()
    }, [])

    const getData = () => {
        let url = []
        url = String(location.pathname).split("/")
        let id = url[url.length - 1]
        api.create().getDetailFAQ(id).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setContent(data.description === undefined ? "" : data.description)
                    setTitle(data.title)
                }

            }
        })
    }

    const handleImageUploadBefore = (files, info, uploadHandler) => {
        // uploadHandler is a function
        console.log(files, info, uploadHandler)
        try {
            ResizeImage(files, uploadHandler)
        } catch (err) {
            uploadHandler(err.toString())
        }
    }
    const handleImageUpload = (targetImgElement, index, state, imageInfo, remainingFilesCount) => {
        console.log(targetImgElement, index, state, imageInfo, remainingFilesCount)
    }

    const handleImageUploadError = (errorMessage, result) => {
        console.log(errorMessage, result)
    }

    const handleEditorChange = (value) => {
        // console.log(value);

        setContent(value)
    }

    const handleDrop = (event) => {
        console.log(event); //Get the drop event
    }

    const handleBlur = (event, editorContents) => {
        // console.log(event, editorContents); //Get the blur event
    }

    const imageUploadHandler = (xmlHttpRequest, info, core) => {
        console.log(xmlHttpRequest, info, core)
    }

    const ResizeImage = (files, uploadHandler) => {
        const uploadFile = files[0];
        const img = document.createElement('img');
        const canvas = document.createElement('canvas');
        const reader = new FileReader();

        reader.onload = function (e) {
            img.src = e.target.result
            img.onload = function () {
                let ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);

                const MAX_WIDTH = 200;
                const MAX_HEIGHT = 100;
                let width = img.width;
                let height = img.height;

                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width;
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                }

                canvas.width = width;
                canvas.height = height;

                ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob(function (blob) {
                    uploadHandler([new File([blob], uploadFile.name)])
                }, uploadFile.type, 1);
            }
        }

        reader.readAsDataURL(uploadFile);
    }

    return (
        <div style={{ height: '100vh' }}>
            <div style={{ padding: '20px 30px' }}>
                <Typography style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: '500' }}>{title}</Typography>
            </div>
            <SunEditor
                // toggleFullScreen={true}
                setContents={content}
                disable={true}
                enableToolbar={false} showToolbar={false} width="100%" height="100%" setOptions={{ resizingBar: false, showPathLabel: false }} />
        </div>
    )
}